$(document).ready(function (){

    document.querySelectorAll('.ol-sc').forEach(card => {
        card.addEventListener('click', function () {

            // Activo visual
            document.querySelectorAll('.ol-sc').forEach(c => c.classList.remove('active'));
            this.classList.add('active');

            const selected = this.dataset.route;
            const orders   = document.querySelectorAll('.ol-card');

            orders.forEach(order => {
                if (selected === 'all' || order.dataset.route === selected) {
                    order.style.display = '';
                } else {
                    order.style.display = 'none';
                }
            });
        });
    });


    $('#orders_table').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "orders/get",
        "columns": [
            {data: 'customer.name'},
            {data: 'doc_num'},
            {data: 'total'},
            {data: 'fecha'},
            {data: 'statuses.description'},

        ],
        "order": [[1, 'desc']],
        "columnDefs": [
            //{ targets: 0, width: '30%' },
            {
                "targets": 4,
                "render": function (data, type, row, meta) {

                    if (row.status !== 'delete') {
                        return "<span class='badge badge-success'><big>" + row.statuses.description + "</big></span>";
                    } else {
                        return "<span class='badge badge-danger'><big>" + row.statuses.description + "</big></span>";
                    }
                }
            },
            {
                "targets": 5,
                "render": function (data, type, row, meta) {

                    if (row.status !== 'Eliminado') {
                        return "<button type='button' class='btn btn-danger btn-sm remove-orders' data-customer='" + row + "' data-bs-toggle='tooltip' title='Eliminar Pedido'><i class='fas fa-trash'></i></button>"
                       /* return "<button type='button' class='btn btn-primary btn-sm edit-orders' data-customer='" + row + "' data-bs-toggle='tooltip' title='Editar Pedido'><i class='fas fa-pencil-alt'></i></button> "
                            + "<button type='button' class='btn btn-primary btn-sm add-items' data-customer-id='" + row.id + "' data-bs-toggle='tooltip' title='Agregar Artículos'><i class='fa fa fa-shopping-cart'></i></button> "
                            + "<button type='button' class='btn btn-danger btn-sm remove-orders' data-customer='" + row + "' data-bs-toggle='tooltip' title='Eliminar Pedido'><i class='fas fa-trash'></i></button>";*/
                    } else {
                        return "<button type='button' class='btn btn-success btn-sm activate-orders' data-id='" + row.id + "' data-bs-toggle='tooltip' title='Reactivar Pedido'><i class='fa fa-check'></i></button> ";
                    }
                }
            },
            //{ targets: 5, width: '20%' },
        ],
        "language": {
            "url": window.location.origin + "/json/Spanish.json"
        },
    });

    $("#import-orders-from-sap").on('click',function (e){
        e.preventDefault()
        $("#modal-import-orders").modal('show')
    })

    $("#import-orders-form").on('submit',function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'/orders/import')
    })

    $('#orders_table tbody').on('click', '.remove-orders', function (e) {
        e.preventDefault();
        let table = $("#orders_table").DataTable();
        let rowData = table.row($(this).parents('tr')).data();
        Swal
            .fire({
                title: "Desea cancelar el pedido del cliente " + rowData.customer.name,
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: "Sí, cancelar",
                cancelButtonText: "Cerrar",
            })
            .then(resultado => {
                if (resultado.value) {

                  let url = window.location.origin + '/orders/order_detail/' + rowData.id + '/delete';

                    $.ajax({
                        url: url,
                        type: 'DELETE',
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        }
                    })
                        .done(function (response) {
                            Swal.fire('Cancelado', 'Se ha cancelado el pedido.', 'success')
                                .then(() => {

                                    let url = window.location.origin + '/orders/get';
                                    $('#orders_table').DataTable().ajax.url(url).load();

                                    //const table = $('#orders_table').DataTable();
                                    //table.ajax.reload(() => table.page(table.page()).draw('page'));

                                });
                        })
                        .fail(function (jqXHR, textStatus) {
                            console.log(jqXHR);
                            alert("Disculpe, existió un problema");
                        });
                }
            });
    });

    function sendData(data, route) {
        $.ajax({
            data: data,
            url: route,
            type: 'POST',
            contentType: false,
            processData: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        }).done(function (response) {

            if (response.success) {
                Swal.fire({
                    title: '',
                    text: response.message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload()
                    }
                });
            }else{
                alertError(response.message)
            }
        }).fail(function (jqXHR, textStatus) {
            console.log(textStatus)
        });
    }
})
